import { Hidden, Tabs } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InfoBarWrapper } from '../../../../../global/components/layout/info-bar-wrapper';
import { genericStepperStyles } from '../../../../../global/constants/theme/styles/components/generic-stepper';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { AccountInfoRoutes } from '../../../../account-info/constants/routes';
import { Employee } from '../../employment/employment-model';
import { NewHireEnrollmentStep } from '../../new-hire-enrollment/models/new-hire-enrollment-models';
import { setCurrentNewHireEnrollmentStep } from '../../new-hire-enrollment/slice/new-hire-enrollment-slices';
import { NameClientNumber } from '../../../../../global/components/name-client-number';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { ParticipantEnrollmentSettings } from '../models/epi-props';
import { ParticipantsEnrollmentRoutes } from '../models/routes';


interface Props {
	basePath: string;
	hideAll?: boolean;
}

export function NewParticipantStepper(props: Props) {

	const { basePath, hideAll } = props;

	const classes = genericStepperStyles();
	const dispatch = useDispatch();
	const currentStep = useSelector<TcsmStates, NewHireEnrollmentStep>(state => state?.newHireEnrollmentState?.currentStep);
	const settings = useSelector<TcsmStates, ParticipantEnrollmentSettings>(state => state?.epiProps?.participantEnrollmentSettingsState?.epiContent);
	const history = useHistory();
	const currentEmployee = useSelector<TcsmStates, Employee>(state => state?.employmentState?.currentEmployee);
	const employmentRecord = `${basePath}${ParticipantsEnrollmentRoutes.ParticipantRecord}`;
	const whoWillEnroll = `${basePath}${ParticipantsEnrollmentRoutes.WhoWillEnroll}`;
	const benefitEnrollment = `${basePath}${ParticipantsEnrollmentRoutes.BenefitEnrollment}${AccountInfoRoutes.PersonalInfoSegment}`;

	const labelSettings = useSelector<TcsmStates, LabelSettingProps>(a => a.epiProps?.labelSettingState?.epiContent);

	const onClick = (step: NewHireEnrollmentStep, url: string) => {
		dispatch(setCurrentNewHireEnrollmentStep(step));
		history.push(url);
	};


	let stepIndex = 0;

	switch (currentStep) {
		case NewHireEnrollmentStep.WHO_WILL_ENROLL:
			stepIndex = 1;
			break;
		case NewHireEnrollmentStep.BENEFIT_ENROLLMENT:
			stepIndex = 2;
			break;

		case NewHireEnrollmentStep.EMPLOYEE_RECORD:
		default:
			stepIndex = 0;
			break;
	}

	if (hideAll) {
		return null;
	}

	return (
		<div className={`${classes.genericStepperContainer} generic-stepper-tabs`}>
			<Hidden mdDown>
				<div className='generic-stepper-tab-desktop'>
					{
						currentStep &&
						<div className='generic-stepper-tab-desktop-inner'>

							<button
								className='generic-stepper-tab-item'
								type='button'
								onClick={() => onClick(NewHireEnrollmentStep.EMPLOYEE_RECORD, employmentRecord)}
								disabled={currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD}
							>
								<span className={`${currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD ? 'h4-styled' : 'h4-alt'}`}>{settings?.newParticipantStepTitle}</span>
							</button>

							<button
								className='generic-stepper-tab-item'
								type='button'
								onClick={() => onClick(NewHireEnrollmentStep.WHO_WILL_ENROLL, whoWillEnroll)}
								disabled={currentStep === NewHireEnrollmentStep.WHO_WILL_ENROLL || (stepIndex < 1)}>
								<span className={`${currentStep === NewHireEnrollmentStep.WHO_WILL_ENROLL ? 'h4-styled' : 'h4-alt'}`}>{settings?.whoWillEnrollStepTitle}</span>
							</button>

							<button
								className='generic-stepper-tab-item'
								type='button'
								onClick={() => onClick(NewHireEnrollmentStep.BENEFIT_ENROLLMENT, benefitEnrollment)}
								disabled={currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT || (stepIndex < 2)}
							>
								<span className={`${currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT ? 'h4-styled' : 'h4-alt'}`}>{settings?.benefitEnrollmentStepTitle}</span>
							</button>

						</div>
					}

					<div className='generic-stepper-infobar'>
						<h4> {settings?.stepperTitle} </h4>
						<NameClientNumber client={currentEmployee} clientNumberLabel={labelSettings?.clientNumberLabel} />
					</div>
				</div>
			</Hidden >
			{/*Below is the Mobile Stepper with mobile infobar*/}
			< Hidden mdUp >
				<InfoBarWrapper>
					<div>
						<h3> {settings?.stepperTitle} </h3>
						<NameClientNumber client={currentEmployee} clientNumberLabel={labelSettings?.clientNumberLabel} />
					</div>
				</InfoBarWrapper>
				{
					currentStep &&
					<Tabs
						value={stepIndex > -1 ? stepIndex : 0}
						variant='scrollable'
						scrollButtons>

						<button
							className='generic-stepper-tab-item'
							type='button'
							onClick={() => onClick(NewHireEnrollmentStep.EMPLOYEE_RECORD, employmentRecord)}
							disabled={currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD}
						>
							<span className={`${currentStep === NewHireEnrollmentStep.EMPLOYEE_RECORD ? 'h4-styled' : 'h4-alt'}`}>{settings?.newParticipantStepTitle}</span>
						</button>

						<button
							className='generic-stepper-tab-item'
							type='button'
							onClick={() => onClick(NewHireEnrollmentStep.WHO_WILL_ENROLL, whoWillEnroll)}
							disabled={currentStep === NewHireEnrollmentStep.WHO_WILL_ENROLL || (stepIndex < 1)}
						>
							<span className={`${currentStep === NewHireEnrollmentStep.WHO_WILL_ENROLL ? 'h4-styled' : 'h4-alt'}`}>{settings?.whoWillEnrollStepTitle}</span>
						</button>

						<button
							className='generic-stepper-tab-item'
							type='button'
							onClick={() => onClick(NewHireEnrollmentStep.BENEFIT_ENROLLMENT, benefitEnrollment)}
							disabled={currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT || (stepIndex < 2)}
						>
							<span className={`${currentStep === NewHireEnrollmentStep.BENEFIT_ENROLLMENT ? 'h4-styled' : 'h4-alt'}`}>{settings?.benefitEnrollmentStepTitle}</span>
						</button>

					</Tabs>
				}
			</Hidden >
		</div >
	);

}

NewParticipantStepper.defaultProps = {
	hideAll: false,
};